import { signal } from "@angular/core";
import { debounce, SchemaPathTree, validate } from "@angular/forms/signals";
const DEFAULT_MAX_TEXT_VALUE = "∞";
const DEFAULT_MIN_TEXT_VALUE = "";

const defaultMaxPrice = 100000000 / 1000000;
const defaultMinPrice = 0;

export interface PriceFilterModel {
    priceFrom: string | null;
    priceTo: string | null;
    expanded: boolean;
}

export function createPriceModel() {
    return signal<PriceFilterModel>({
        priceFrom: DEFAULT_MIN_TEXT_VALUE,
        priceTo: DEFAULT_MAX_TEXT_VALUE,
        expanded: true,
    });
}

export function buildPriceModel(a: SchemaPathTree<PriceFilterModel>) {
    debounce(a.priceFrom, 300);
    debounce(a.priceTo, 300);
    maxPriceValidator(a.priceTo);
    minPriceValidator(a.priceFrom, a.priceTo);
}

function maxPriceValidator(field: any) {
    validate(field, ({ value }) => {
        const maxPrice = value();
        if (defaultMinPrice != null && +maxPrice < defaultMinPrice) {
            return {
                kind: "belowLimit",
                message: `Fra-verdi er lavere enn tillatt minsteverdi (${defaultMinPrice}).`,
            };
        } else if (defaultMaxPrice != null && +maxPrice > defaultMaxPrice) {
            return {
                kind: "aboveLimit",
                message: `Til-verdi er høyere enn tillatt maksverdi (${defaultMaxPrice}).`,
            };
        }
        return null;
    });
}

function minPriceValidator(field: any, validateAgainstField?: any) {
    validate(field, ({ value, valueOf }) => {
        let minPrice = value();
        let maxPrice = valueOf(validateAgainstField);
        if (defaultMinPrice != null && +minPrice < defaultMinPrice) {
            return {
                kind: "belowLimit",
                message: `Fra-verdi er lavere enn tillatt minsteverdi (${defaultMinPrice}).`,
            };
        } else if (defaultMaxPrice != null && +minPrice > defaultMaxPrice) {
            return {
                kind: "aboveLimit",
                message: `Til-verdi er høyere enn tillatt maksverdi (${defaultMaxPrice}).`,
            };
        } else if (maxPrice != null && maxPrice != "" && +minPrice > +maxPrice) {
            return {
                kind: "aboveMax",
                message: "Fra-verdi er høyere enn Til-verdi.",
            };
        }
        return null;
    });
}
